import React, { FC } from 'react'
import { TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { FeedbackErrorHandler as ErrorHandler } from '../ErrorHandler'
import { FeedbackViewDataLoader } from './FeedbackViewDataLoader'
import { FeedbackDetailView } from './FeedbackDetailView'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import routePath from 'router/routePath'

export const FeedbackView: FC = () => {
  const { t } = useTranslation(['common', 'feedback', 'titles'])
  const { currentContractId } = useCurrentContract()

  const backPath = routePath.contactInfo.replace(
    ':contractId',
    currentContractId
  )

  const backText = t('titles:contactInformation')

  return (
    <TitleController title={t('feedback:headings.feedback')}>
      <ResidentAppView
        title={t('feedback:headings.givenFeedback')}
        backLink={
          <ResidentAppBackLink href={backPath}>{backText}</ResidentAppBackLink>
        }
      >
        <ResidentAppCard>
          <ErrorHandler>
            <FeedbackViewDataLoader>
              {({ feedbackNotice, user }) => (
                <FeedbackDetailView
                  existingNotice={feedbackNotice}
                  user={user}
                />
              )}
            </FeedbackViewDataLoader>
          </ErrorHandler>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
